export default {
    connectVersion: '1.0',
    apiVersion: 'v2.0',
    locale: 'da-DK',
    frontendUrl: process.env.VUE_APP_SITE_HOST,
    apiUrl: process.env.VUE_APP_API_URL
};